import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CyclesLocationCallout } from 'modules/bookkeepers/components/CyclesLocationCallout'
import useGetCycleCount from 'modules/bookkeepers/hooks/useGetCycleCount'
import useGetPayrollResults from 'modules/bookkeepers/hooks/useGetPayrollResults'

import PayrollResultsDataTable from './PayrollResultsDataTable'

const PayrollResults = () => {
  const { payrollResults } = useGetPayrollResults()
  const { cyclesCount } = useGetCycleCount()
  const payrollResultsCount = payrollResults.length

  const showCallout = cyclesCount > 0 && payrollResultsCount > 0

  return (
    <Box width="full" flexDirection="column" padding="s24" gap="s12">
      <Box gap="s6" flexDirection="row" paddingBottom="s24">
        <Text.Normal weight="bold">
          {i18n.t('bookkeepers.clients.payroll_dashboard.title')}
        </Text.Normal>
      </Box>

      {showCallout && <CyclesLocationCallout />}
      <PayrollResultsDataTable />
    </Box>
  )
}

export default PayrollResults
